




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { GoogleBmAgent } from '../models/googleBmAgent';
import VueQrcode from '@chenfengyuan/vue-qrcode';

@Component({
	components: {
		VueQrcode
	}
})
export default class GoogleBmAgentTestModal extends Vue {
	@Prop() public agent: GoogleBmAgent;

	public activeTab: 'androidMaps' | 'iosMaps' | 'androidWeb' = 'androidMaps';

	public isActiveTab(tab: 'androidMaps' | 'iosMaps' | 'androidWeb') {
		return this.activeTab === tab;
	}

	public selectTab(tab: 'androidMaps' | 'iosMaps' | 'androidWeb') {
		return this.activeTab = tab;
	}

	public get testUrl(): string {
		if (this.activeTab === 'androidMaps') {
			return this.agent!.androidMapsUrl;
		} else if (this.activeTab === 'iosMaps') {
			return this.agent!.iosMapsUrl;
		} else if (this.activeTab === 'androidWeb') {
			return this.agent!.androidWebUrl;
		}
		return '';
	}
}
